export default "__VITE_ASSET__j39MTasM__"